import firebase from 'infrastructure/firebase'
import { atom } from 'infrastructure/state/jotai.wrapper'

type AdditionalUserInfo = firebase.auth.AdditionalUserInfo

type googleLoginInitialState = {
  user: undefined
  credential: undefined
  additionalUserInfo?: undefined
}

const initialState = {
  user: undefined,
  credential: undefined,
} satisfies googleLoginInitialState

interface googleAuthCredential extends firebase.auth.AuthCredential {
  accessToken: string
}

interface googleAuth extends firebase.auth.UserCredential {
  credential: googleAuthCredential
  additionalUserInfo?: AdditionalUserInfo
}

export type GoogleUserAtomValue = googleAuth | googleLoginInitialState

export const internalGoogleUserAtom = atom<GoogleUserAtomValue>(initialState)

export const googleUserAtom = atom(
  (get) => {
    return get(internalGoogleUserAtom)
  },
  (_, set) => {
    set(internalGoogleUserAtom, initialState)
  },
)

export const googleLoginError = atom<unknown>(undefined)
